import { pushWithRegion } from 'actions/NavigationActions'
import { CheckoutPageId } from 'checkout/constants/pages'
import { getCheckoutPathWithCartId } from 'lib/url/pathsUtils'
import { resetFlightsTimer } from 'components/Flights/FlightsSessionTimer/FlightsSessionTimer'
import { getSelectedTourFlightItems, isTourFlightUpsellAvailable, tourFlightNeedsRefresh } from 'checkout/selectors/tourFlightSelectors'
import qs from 'qs'
import { addItem, updateCheckoutItem } from 'actions/CheckoutActions'
import type { AppAction } from 'actions/types/ActionTypes'
import { TOUR_FLIGHT_SEARCH_FIXTURE } from 'checkout/fixtures/tourFlightSearch'
import { generatePassengersFromOccupants } from 'checkout/lib/utils/flights/passenger'
import { getNonCharterFlightItems } from 'checkout/selectors/view/flights'
import { fareClassToUrlMap } from 'constants/flight'
import { generateFlightCheckoutItem } from 'lib/checkout/flights/cart'

/** Reuse a leg's draft on back navigation; never bundle it with the tour price. */
export function prepareTourFlightLeg(leg: 'departing' | 'returning'): AppAction {
  return (dispatch, getState) => {
    if (!isTourFlightUpsellAvailable(getState())) return

    // TODO: use the actual search data from the server
    const search = TOUR_FLIGHT_SEARCH_FIXTURE[leg]
    const itinerary = search.itinerary[0]
    let item = getNonCharterFlightItems(getState()).find(item => item.tourFlightLeg === leg)
    if (!item) {
      item = {
        ...generateFlightCheckoutItem({
          originAirportCode: itinerary.departureAirport,
          destinationAirportCode: itinerary.arrivalAirport,
          occupants: search.occupancies[0],
          passengers: generatePassengersFromOccupants(search.occupancies[0]),
          fareType: search.fareType,
          viewType: search.viewType,
          selectedCabinClass: search.fareClass,
        }),
        tourFlightLeg: leg,
      }
      dispatch(addItem(item))
    }
    return qs.stringify({
      flightItemId: item.itemId,
      originAirportCode: item.originAirportCode,
      destinationAirportCode: item.destinationAirportCode,
      departDate: itinerary.departureDate,
      fareClass: fareClassToUrlMap[search.fareClass],
    })
  }
}

/** Clear expired selected legs and restart at the first one in checkout order. */
export function refreshTourFlightSearch(leg?: 'departing' | 'returning'): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    if (!isTourFlightUpsellAvailable(state)) return
    const selected = getSelectedTourFlightItems(state)
    const expired = selected.filter(item => tourFlightNeedsRefresh(item, state))
    const flights = getNonCharterFlightItems(state).filter(item => item.tourFlightLeg)
    const item = expired[0] ?? selected.find(item => item.tourFlightLeg === leg) ?? selected[0] ?? flights.find(item => item.tourFlightLeg === leg) ?? flights[0]
    if (!item?.tourFlightLeg) return

    for (const flight of expired.length ? expired : [item]) {
      dispatch(updateCheckoutItem({
        ...flight,
        flights: [],
        searchId: undefined,
        expiry: undefined,
        hasFinalFare: false,
        fareFetchError: undefined,
      }))
    }
    const search = dispatch(prepareTourFlightLeg(item.tourFlightLeg))
    const page = item.tourFlightLeg === 'departing' ? CheckoutPageId.DepartingFlights : CheckoutPageId.ReturningFlights
    resetFlightsTimer()
    dispatch(pushWithRegion(getCheckoutPathWithCartId(page, state.checkout.cart.cartId), qs.stringify({
      ...qs.parse(search),
      key: Date.now(),
    })))
  }
}
